import { createStore } from 'vuex'

import user from './modules/user'
import setting from './modules/setting'
import tagView from './modules/tagView'
import condition from './modules/condition'
import notice from './modules/notice'

var store = createStore({
  state: {
    // 顶部菜单权限缓存，避免重复请求
    topMenu: null
  },
  mutations: {
    SET_TOP_MENU(state, menu) {
      state.topMenu = menu
    }
  },
  modules: {
    user: user,
    setting: setting,
    tagView: tagView,
    condition: condition,
    notice: notice
  }
})

export default store;

